module.exports = __webpack_public_path__ + "static/media/portsight.363b6709.png";